import { getRecoil, setRecoil } from 'recoil-nexus';

import { isJSON } from 'lib/helpers/utility';

import {
  generalChatActivePromptConversationsState,
  generalChatActivePromptIdState,
  generalChatGenerating,
  generalChatIdState,
  generalChatLoading,
  generalChatMessageIdState,
  generalChatPromptListState
} from 'components/admin/components/GeneralAIChat/state';

const chunkBuffers = {};
let isGenerationStarted = false;
const updateGeneralChat = (data) => {
  const {
    vertical,
    response: r,
    done = false,
    abort = false,
    isRegenerate = false,
    isDescription = false,
    ...rest
  } = data;
  let response = r;

  if (isJSON(r)) {
    response = JSON.parse(r);
  }

  const activePromptConversations = getRecoil(generalChatActivePromptConversationsState);
  const isFollowUp = activePromptConversations?.length > 2;

  if (isDescription) {
    setRecoil(generalChatPromptListState, (prevPrompts = []) => {
      if (prevPrompts?.[0]?.id === rest?.intelligence_chat_id) {
        const nextPrompts = [...prevPrompts];
        nextPrompts[0] = {
          id: rest?.intelligence_chat_id,
          name: data?.intelligenceChat?.name,
          description: data?.intelligenceChat?.description
        };
        return nextPrompts;
      }
      return prevPrompts;
    });
    return;
  }

  try {
    const intelligenceChatId = getRecoil(generalChatIdState);
    if (rest?.intelligence_chat_id && intelligenceChatId) {
      if (rest?.intelligence_chat_id !== intelligenceChatId) {
        return;
      }
    }

    if (!isGenerationStarted) {
      if (!isFollowUp) {
        setRecoil(generalChatPromptListState, (prevPrompts) => {
          if (prevPrompts?.[0]?.id === rest?.intelligence_chat_id) {
            return prevPrompts;
          }
          const newPrompt = {
            id: rest?.intelligence_chat_id,
            name: 'New Note'
          };

          return [newPrompt, ...prevPrompts];
        });
      }
      setRecoil(generalChatGenerating, true);
      isGenerationStarted = true;
    }

    if (done || abort) {
      setRecoil(generalChatLoading, false);
      isGenerationStarted = false;
    }

    if (rest?.intelligence_chat_id) {
      setRecoil(generalChatIdState, rest?.intelligence_chat_id);
    }

    setPromptStates({
      done,
      abort,
      response,
      jsonResponse: response,
      path: vertical,
      isRegenerate,
      isFollowUp,
      ...rest
    });
  } catch (error) {
    console.error('❌ Error', error);
  }
};

const setPromptStates = (intelligenceAi) => {
  if (intelligenceAi?.response) {
    setRecoil(generalChatActivePromptIdState, intelligenceAi?.intelligence_chat_id);
    if (intelligenceAi?.done || intelligenceAi?.abort) {
      if (intelligenceAi?.intelligenceChatMessage) {
        setRecoil(generalChatMessageIdState, intelligenceAi?.intelligenceChatMessage?.id);
        setRecoil(generalChatActivePromptConversationsState, (prevState) => {
          let newPrompt = [...prevState];
          if (newPrompt[newPrompt?.length - 1]?.agent === 'ai') {
            newPrompt[newPrompt?.length - 1] = {
              ...intelligenceAi?.intelligenceChatMessage,
              emCPTs: intelligenceAi?.emCPTs,
              note: intelligenceAi?.note
            };
          } else {
            newPrompt = [
              ...prevState,
              {
                ...intelligenceAi?.intelligenceChatMessage,
                emCPTsText: intelligenceAi?.emCPTsText,
                note: intelligenceAi?.note
              }
            ];
          }
          return newPrompt;
        });
      }
      setRecoil(generalChatGenerating, false);
    }

    if (!intelligenceAi?.isNote || intelligenceAi?.done) {
      const chatId = intelligenceAi?.intelligence_chat_id;
      const orderId = intelligenceAi?.response.orderId;
      const value = intelligenceAi?.response.value;
      const isLast = intelligenceAi?.done;

      if (!chunkBuffers[chatId]) {
        chunkBuffers[chatId] = { chunks: {}, lastIndex: null, latestCompleteMessage: '' };
      }

      const buffer = chunkBuffers[chatId];
      buffer.chunks[orderId] = value;

      if (isLast) {
        buffer.lastIndex = orderId;
      }

      // Assemble continuous chunks starting from 0
      const assembled = [];
      let i = 0;
      while (buffer.chunks[i] !== undefined) {
        assembled.push(buffer.chunks[i]);
        i++;
      }

      const fullMessage = assembled.join('');
      buffer.latestCompleteMessage = fullMessage;

      const newMessageObj = {
        id: intelligenceAi?.intelligenceChatMessage?.id || self.crypto.randomUUID(),
        message: fullMessage,
        isNote: intelligenceAi?.isNote,
        note: intelligenceAi?.note,
        emCPTsText: intelligenceAi?.emCPTsText,
        agent: 'ai'
      };

      setRecoil(generalChatActivePromptConversationsState, (prevState) => {
        let newConversation = [...prevState];
        if (newConversation[newConversation?.length - 1]?.agent === 'ai') {
          newConversation[newConversation?.length - 1] = newMessageObj;
        } else {
          newConversation = [...prevState, newMessageObj];
        }
        return newConversation;
      });
    }
  }
};

export default updateGeneralChat;
